import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@sm/wds-react';
import { getAnonCategories } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';

const AnonFooterLinks = ({ domain, lang, country, variant }) => {
  const categories = getAnonCategories(domain, lang, country, variant);
  const margin = variant === 'slim';
  return (
    <>
      {categories.map(category => {
        return (
          <Row key={category[0].title}>
            <Col>
              <InlineList noMargin={margin}>
                {category.map(item => {
                  return (
                    <InlineListItem
                      href={item.url}
                      key={`${item.title}`}
                      isTitle={item.isTitle}
                      lastItem={item.lastItem}
                    >
                      {item.title}
                    </InlineListItem>
                  );
                })}
              </InlineList>
            </Col>
          </Row>
        );
      })}
    </>
  );
};

AnonFooterLinks.propTypes = {
  domain: PropTypes.string,
  lang: PropTypes.string,
  country: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'slim'])
};

AnonFooterLinks.defaultProps = {
  domain: 'surveymonkey',
  lang: 'en',
  country: 'US',
  variant: 'default'
};

export default AnonFooterLinks;
